import { Component } from '@angular/core';
import { SynSpinnerComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-spinner',
  template: ` <syn-spinner id="spinner"></syn-spinner> `,
  styles: [],
  imports: [SynSpinnerComponent],
})
export class SpinnerComponent {}
